<template>
    <div class="settings-api-config" v-loading="loading">
        <el-card shadow="never">
            <el-form label-width="180px" size="small">
                <el-form-item label="启用企业信息自动匹配">
                    <el-switch v-model="autoMatchEnabled" active-text="启用" inactive-text="关闭" />
                </el-form-item>
                <el-form-item label="企业匹配API地址">
                    <el-input v-model.trim="form.match_endpoint" placeholder="例如：https://api.example.com/company/match" />
                </el-form-item>
                <el-form-item label="企业匹配API Token">
                    <el-input v-model.trim="form.match_token" show-password />
                </el-form-item>
                <el-form-item label="匹配超时（秒）">
                    <el-input-number v-model="form.match_timeout_seconds" :min="3" :max="120" />
                </el-form-item>

                <el-divider content-position="left">注销结果识别与自动完结</el-divider>

                <el-form-item label="启用自动完结">
                    <el-switch v-model="autoCompleteEnabled" active-text="启用" inactive-text="关闭" />
                </el-form-item>
                <el-form-item label="结果查询API地址">
                    <el-input v-model.trim="form.complete_check_endpoint" placeholder="例如：https://api.example.com/cancel/check" />
                </el-form-item>
                <el-form-item label="结果查询API Token">
                    <el-input v-model.trim="form.complete_token" show-password />
                </el-form-item>
                <el-form-item label="轮询间隔（分钟）">
                    <el-input-number v-model="form.complete_poll_minutes" :min="1" :max="1440" />
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="saving" @click="save">保存配置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'SettingsApiConfig',
    data() {
        return {
            loading: false,
            saving: false,
            form: {
                auto_match_enabled: 0,
                match_endpoint: '',
                match_token: '',
                match_timeout_seconds: 10,
                auto_complete_enabled: 0,
                complete_check_endpoint: '',
                complete_token: '',
                complete_poll_minutes: 30
            }
        };
    },
    computed: {
        autoMatchEnabled: {
            get() {
                return Number(this.form.auto_match_enabled) === 1;
            },
            set(value) {
                this.form.auto_match_enabled = value ? 1 : 0;
            }
        },
        autoCompleteEnabled: {
            get() {
                return Number(this.form.auto_complete_enabled) === 1;
            },
            set(value) {
                this.form.auto_complete_enabled = value ? 1 : 0;
            }
        }
    },
    created() {
        this.fetchConfig();
    },
    methods: {
        fetchConfig() {
            var _this = this;
            this.loading = true;
            window.axios.get('/system-config/api').then(function (response) {
                _this.form = Object.assign({}, _this.form, response.data.data || {});
            }).catch(function () {
                _this.$message.error('加载API配置失败');
            }).finally(function () {
                _this.loading = false;
            });
        },
        save() {
            var _this = this;
            this.saving = true;
            window.axios.put('/system-config/api', this.form).then(function () {
                _this.$message.success('API配置已保存');
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        }
    }
};
</script>

<style scoped>
.settings-api-config {
    padding: 0;
}

.settings-api-config /deep/ .el-divider__text {
    color: #4f5b6a;
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsApiConfig.vue